import { Cookies } from 'react-cookie';

import { objectHeaderData } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getObjectHeaderData = async (slug: string) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get(`/object/bread_crump_data/${slug}`, {
    headers: {
      Authorization: token,
    },
  });

  return data.data as objectHeaderData;
};
